import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";

import {
  LuChevronDown,
  LuChevronUp,
} from "react-icons/lu";

import "../assets/css/Faqs.css";

const faqData = [
  {
    question: "What services will you be providing?",
    answer:
      "At Outcess we provide the following solutions: - Business Process Outsourcing and Customer Engagement - We deliver successful customer acquisition, retention and growth for our clients by leveraging technology and software solutions."
  },
  {
    question: "How do you intend to provide customer satisfaction?",
    answer:
      "Research has it that attracting a new customer costs 5 times more than keeping existing ones. We understand the benefits of satisfying current customers, which is why we strongly support Customer Engagement. We provide every means possible through which customers can reach out to companies and have their issues resolved at the best time possible."
  },
  {
    question: "Does this service apply to small-scale businesses?",
    answer:
      "Our unique service spreads out to diverse businesses, regardless of the type, size or particular sector of the economy they fall into."
  },
  {
    question: "How can we help your business?",
    answer:
      "Through collaboration with customers to understand their needs, we build trust, offer appropriate advice, and recommend suitable technology to transform your business."
  },
  {
    question: "What are the advantages of Outcess?",
    answer:
      "Outcess takes every detail into consideration to make sure systems run smoothly and responsively. We use modern technology to secure customers' databases and build highly confidential firewalls."
  }
];

const FAQs = () => {
  const [show, setShow] = useState(false);
  const [active, setActive] = useState(0);

  const toggleFaq = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <div id="faqs-page">

      <Navbar />

      <RFQModal
        show={show}
        setShow={setShow}
      />

      {/* HERO */}

      <section className="faq-hero">

        <div className="container">

          <span className="faq-tag">
            FAQS
          </span>

          <h1>
            Questions<br /> people actually ask us.
          </h1>

          <p>
            Everything you need to know
            about Outcess.
          </p>

        </div>

      </section>

      {/* FAQ SECTION */}

      <section className="faq-section">

        <div className="container faq-container ">

          {faqData.map((item, index) => (

            <div
              className={`faq-item ${
                active === index ? "active" : ""
              }`}
              key={index}
            >

              <button
                className="faq-question"
                onClick={() => toggleFaq(index)}
              >

                <span>{item.question}</span>

                {active === index ? (
                  <LuChevronUp />
                ) : (
                  <LuChevronDown />
                )}

              </button>

              <div className="faq-answer">

                <p>
                  {item.answer}
                </p>

              </div>

            </div>

          ))}

        </div>

      </section>

      {/* CTA */}

      <section className="faq-cta">

        <div className="container ">

          <span className="faq-tag">
            STILL HAVE QUESTIONS?
          </span>

          <h2>
            Ask us directly.
            We'll give you a straight answer.
          </h2>

          <p>
            Book a short consultation and we'll walk
            through exactly what fits your business.
          </p>

          <button
            className="ccsnl-btn"
            onClick={() => setShow(true)}
          >
            Book a Demo
          </button>

        </div>

      </section>

      <Footer />

    </div>
  );
};

export default FAQs;
